export default function () {
    $('.Select .Select-input').on('change', function (e) {
        let selected = $(this).find('option:selected');
        let linkStr = selected.data('link');
        if (linkStr) {
            window.location.href = linkStr;
        } 
    })
}